// extracted by mini-css-extract-plugin
export default {"YoutubeEmbed":"bap_a"};